import React, { useEffect, useState } from 'react'
import Papa from 'papaparse'

const behaviorCSV = 'https://anandstaticstagingcountrycoderequest.s3.ap-south-1.amazonaws.com/digiadglobal-anylatics/data-Manage-Behavior.csv'
const signalsCSV = 'https://anandstaticstagingcountrycoderequest.s3.ap-south-1.amazonaws.com/digiadglobal-anylatics/data-Signals.csv'

const BehaviorsContentSignals = () => {
  const [behaviorData, setBehaviorData] = useState([])
  const [signalsData, setSignalsData] = useState([])
  const [activeTab, setActiveTab] = useState('content')
  const [expanded, setExpanded] = useState({})
  const [currentPage, setCurrentPage] = useState(1)
  const [selectedDomain, setSelectedDomain] = useState('all')
  const rowsPerPage = 1000

  useEffect(() => {
    fetch(behaviorCSV)
      .then(res => res.text())
      .then(text => {
        Papa.parse(text, {
          header: true,
          skipEmptyLines: true,
          transformHeader: header => header.trim(),
          complete: (results) => setBehaviorData(results.data),
        })
      })

    fetch(signalsCSV)
      .then(res => res.text())
      .then(text => {
        Papa.parse(text, {
          header: true,
          skipEmptyLines: true,
          transformHeader: header => header.trim(),
          complete: (results) => setSignalsData(results.data),
        })
      })
  }, [])

  const toggleExpand = (key) => {
    setExpanded((prev) => ({ ...prev, [key]: !prev[key] }))
  }

  const parseNumber = (value) => {
    const num = parseFloat(value)
    return isNaN(num) ? 0 : num
  }

  const sumChildren = (node) => {
    let totalUniques = 0
    let totalPageviews = 0

    if (node.metrics) {
      totalUniques += parseNumber(node.metrics.uniques)
      totalPageviews += parseNumber(node.metrics.pageviews)
    }

    if (node.children) {
      for (const key in node.children) {
        const child = node.children[key]
        const childSums = sumChildren(child)
        totalUniques += childSums.uniques
        totalPageviews += childSums.pageviews
      }
    }

    node.totals = {
      uniques: Math.round(totalUniques),
      pageviews: Math.round(totalPageviews),
    }

    return { uniques: totalUniques, pageviews: totalPageviews }
  }

  const groupByBehavior = () => {
    const grouped = {}

    behaviorData.forEach((row) => {
      const b1 = row['Behaviors']
      const b2 = row['Sub Behavior 1']
      const b3 = row['Sub Behavior 2']
      const b4 = row['Sub Behavior 3']
      const uniques = row['Uniques User Million']
      const pageviews = row['Pageviews in Million']

      if (!grouped[b1]) {
        grouped[b1] = { metrics: {}, children: {} }
      }

      if (b2) {
        if (!grouped[b1].children[b2]) {
          grouped[b1].children[b2] = { metrics: {}, children: {} }
        }

        if (b3) {
          if (!grouped[b1].children[b2].children[b3]) {
            grouped[b1].children[b2].children[b3] = { metrics: {}, children: {} }
          }

          if (b4) {
            grouped[b1].children[b2].children[b3].children[b4] = { metrics: { uniques, pageviews } }
          } else {
            grouped[b1].children[b2].children[b3].metrics = { uniques, pageviews }
          }
        } else {
          grouped[b1].children[b2].metrics = { uniques, pageviews }
        }
      } else {
        grouped[b1].metrics = { uniques, pageviews }
      }
    })

    Object.values(grouped).forEach((node) => sumChildren(node))
    return grouped
  }

  const groupedData = groupByBehavior()

  const sortedSignals = [...signalsData].sort((a, b) => new Date(b.ts) - new Date(a.ts))

  const getUniqueDomains = () => {
    const domainSet = new Set()
    signalsData.forEach(row => {
      try {
        const domain = new URL(row.url).hostname
        domainSet.add(domain)
      } catch {}
    })
    return ['all', ...Array.from(domainSet)]
  }

  const filteredSignals = selectedDomain === 'all'
    ? sortedSignals
    : sortedSignals.filter(row => {
        try {
          return new URL(row.url).hostname === selectedDomain
        } catch {
          return false
        }
      })

  // Replace existing lines with these:

const totalPages = Math.ceil(filteredSignals.length / rowsPerPage)
const paginatedSignals = filteredSignals.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage)



  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prev) => prev + 1)
  }

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage((prev) => prev - 1)
  }

  return (
    <div className="p-6 bg-white rounded shadow">
      <h2 className="text-2xl font-semibold mb-4 text-gray-800">Manage Behaviors</h2>

      {/* Tabs */}
      <div className="flex border-b mb-4">
        <button
          className={`px-6 py-2 border-b-2 font-medium ${activeTab === 'content' ? 'border-black text-black' : 'border-transparent text-gray-500'}`}
          onClick={() => setActiveTab('content')}
        >
          Manage Behavior
        </button>
        <button
          className={`px-6 py-2 border-b-2 font-medium ${activeTab === 'manage' ? 'border-black text-black' : 'border-transparent text-gray-500'}`}
          onClick={() => setActiveTab('manage')}
        >
          Manage Signals
        </button>
      </div>

      {/* Behavior Tab */}
      {activeTab === 'content' && (
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border">
            <thead>
              <tr className="bg-gray-50 text-left text-sm font-semibold text-gray-600">
                <th className="px-4 py-2 border-b">Label</th>
                <th className="px-4 py-2 border-b">Uniques User (Million)</th>
                <th className="px-4 py-2 border-b">Pageviews (Million)</th>
              </tr>
            </thead>
            <tbody>
  {Object.entries(groupedData).map(([b1, b1Data]) => {
    const b1Key = b1;
    const hasB1Children = b1Data.children && Object.keys(b1Data.children).length > 0;

    return (
      <React.Fragment key={b1Key}>
        <tr
          className={hasB1Children ? "cursor-pointer hover:bg-gray-100" : ""}
          onClick={() => hasB1Children && toggleExpand(b1Key)}
        >
          <td className="px-4 py-2 font-bold border-b">
            {hasB1Children ? (expanded[b1Key] ? '▾' : '▸') : ''} {b1}
          </td>
          <td className="px-4 py-2 border-b">{b1Data.totals?.uniques}</td>
          <td className="px-4 py-2 border-b">{b1Data.totals?.pageviews}</td>
        </tr>

        {expanded[b1Key] && hasB1Children && Object.entries(b1Data.children).map(([b2, b2Data]) => {
          const b2Key = `${b1Key}-${b2}`;
          const hasB2Children = b2Data.children && Object.keys(b2Data.children).length > 0;

          return (
            <React.Fragment key={b2Key}>
              <tr
                className={hasB2Children ? "cursor-pointer hover:bg-gray-50" : ""}
                onClick={() => hasB2Children && toggleExpand(b2Key)}
              >
                <td className="pl-8 px-4 py-2 text-gray-700 border-b">
                  {hasB2Children ? (expanded[b2Key] ? '▾' : '▸') : ''} {b2}
                </td>
                <td className="px-4 py-2 border-b">{b2Data.totals?.uniques}</td>
                <td className="px-4 py-2 border-b">{b2Data.totals?.pageviews}</td>
              </tr>

              {expanded[b2Key] && hasB2Children && Object.entries(b2Data.children).map(([b3, b3Data]) => {
                const b3Key = `${b2Key}-${b3}`;
                const hasB3Children = b3Data.children && Object.keys(b3Data.children).length > 0;

                return (
                  <React.Fragment key={b3Key}>
                    <tr
                      className={hasB3Children ? "cursor-pointer hover:bg-gray-50" : ""}
                      onClick={() => hasB3Children && toggleExpand(b3Key)}
                    >
                      <td className="pl-16 px-4 py-2 text-gray-600 border-b">
                        {hasB3Children ? (expanded[b3Key] ? '▾' : '▸') : ''} {b3}
                      </td>
                      <td className="px-4 py-2 border-b">{b3Data.totals?.uniques}</td>
                      <td className="px-4 py-2 border-b">{b3Data.totals?.pageviews}</td>
                    </tr>

                    {expanded[b3Key] && hasB3Children && Object.entries(b3Data.children).map(([b4, b4Data]) => (
                      <tr key={`${b3Key}-${b4}`} className="hover:bg-gray-50">
                        <td className="pl-24 px-4 py-2 text-gray-500 border-b">{b4}</td>
                        <td className="px-4 py-2 border-b">{b4Data.metrics?.uniques}</td>
                        <td className="px-4 py-2 border-b">{b4Data.metrics?.pageviews}</td>
                      </tr>
                    ))}

                  </React.Fragment>
                );
              })}
            </React.Fragment>
          );
        })}
      </React.Fragment>
    );
  })}
</tbody>

          </table>
        </div>
      )}

      {/* Signals Tab */}
      {activeTab === 'manage' && (
        <div className="overflow-x-auto">
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Filter by Domain</label>
            <select
              className="border border-gray-300 rounded px-3 py-1 text-sm"
              value={selectedDomain}
              onChange={(e) => {
                setSelectedDomain(e.target.value)
                setCurrentPage(1)
              }}
            >
              {getUniqueDomains().map((domain) => (
                <option key={domain} value={domain}>
                  {domain === 'all' ? 'All Domains' : domain}
                </option>
              ))}
            </select>
          </div>

          <table className="min-w-full bg-white border">
            <thead>
              <tr className="bg-gray-50 text-left text-sm font-semibold text-gray-600">
                <th className="px-4 py-2 border-b">S. No.</th>
                <th className="px-4 py-2 border-b">user_id</th>
                <th className="px-4 py-2 border-b max-w-[200px] break-words whitespace-normal">url</th>
              </tr>
            </thead>
            <tbody>
              {paginatedSignals.map((row, index) => (
                <tr key={index} className="text-sm text-gray-700 hover:bg-gray-50">
                  <td className="px-4 py-2 border-b">{(currentPage - 1) * rowsPerPage + index + 1}</td>
                  <td className="px-4 py-2 border-b">{row.user_id}</td>
                  <td className="px-4 py-2 border-b break-words max-w-[200px] whitespace-normal">{row.url}</td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Pagination Controls */}
          <div className="mt-4 flex justify-center items-center gap-2 flex-wrap">
            <button
              onClick={handlePrevPage}
              disabled={currentPage === 1}
              className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
            >
              Previous
            </button>
            {Array.from({ length: 20 }, (_, i) => {
              const pageNumber = Math.floor((currentPage - 1) / 20) * 20 + i + 1
              if (pageNumber > totalPages) return null
              return (
                <button
                  key={pageNumber}
                  onClick={() => setCurrentPage(pageNumber)}
                  className={`px-3 py-1 rounded ${
                    currentPage === pageNumber
                      ? 'bg-black text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-300'
                  }`}
                >
                  {pageNumber}
                </button>
              )
            })}
            <button
              onClick={handleNextPage}
              disabled={currentPage === totalPages}
              className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
            >
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export default BehaviorsContentSignals